import { forwardRef, FunctionComponent, memo } from "react";
import classNames from "classnames";
import { default as InputNumber, InputNumberProps } from "rc-input-number";
import { Input, InputProps } from "../Input";

import styles from "./style.module.scss";

export type NumberFieldProps = Omit<InputProps<InputNumberProps<number>>, "component">

export const NumberField = memo(forwardRef<HTMLInputElement, NumberFieldProps>((
  {
    className,
    ...props
  }, ref) => {

  return <Input
    {...props}
    className={classNames(className, styles.root)}
    prefixCls="number-field"
    ref={ref}
    component={InputNumber as FunctionComponent<InputNumberProps<number>>}
  />;
}));

export default NumberField;



